<template>
  <div style="padding: 20px">
    <div style="display:flex;">
      <select-area @areaListId="getAreaListId"/>
      <div style="margin-bottom: 20px">
        <el-input v-model="query.coachName" placeholder="教练姓名" style="width: 160px;margin-right: 10px"/>
<!--        <el-select style="width: 140px;margin: 0 10px"-->
<!--                   v-model="query.coachType"-->
<!--                   placeholder="教练类型"-->
<!--                   clearable-->
<!--        >-->
<!--          <el-option key="1" label="全职" :value="1"></el-option>-->
<!--          <el-option key="0" label="兼职" :value="0"></el-option>-->
<!--        </el-select>-->
<!--        <el-select style="width: 140px;margin: 0 10px"-->
<!--                   v-model="query.isVerify"-->
<!--                   placeholder="是否确认"-->
<!--                   clearable-->
<!--        >-->
<!--          <el-option key="1" label="是" :value="1"></el-option>-->
<!--          <el-option key="0" label="否" :value="0"></el-option>-->
<!--        </el-select>-->
        <el-date-picker
            v-model="yearAndMonth"
            type="month"
            style="width: 170px;"
            value-format="YYYY-MM"
            placeholder="日期选择">
        </el-date-picker>
        <el-button
            type="primary"
            style="margin-left: 10px"
            @click="confirmPerformanceList"
        >搜索
        </el-button>
        <el-popconfirm @confirm="exportConfirmPerformance" title="确定要导出吗？">
          <template #reference>
            <el-button v-permission="['PerformanceConfirm:export']" type="primary">导出</el-button>
          </template>
        </el-popconfirm>
      </div>
    </div>
    <el-table
        :data="tableData"
        border
        v-loading="tableLoading"
        height="606px"
        ref="multipleTable"
        :row-style="{ height: '15px' }"
        :cell-style="{ padding: '0px' }"
        header-cell-class-name="table-header"
    >
      <el-table-column prop="coachId" label="教练Id" min-width="90" align="center"/>
      <el-table-column prop="coachName" label="教练姓名" min-width="110" align="center"/>
      <el-table-column prop="cityName" label="城市" min-width="300" align="center">
        <template #default="scope">
          <span>{{ scope.row.cityName }}-{{scope.row.areaName}} <el-tag size="small" v-if="scope.row.flag">{{ scope.row.flag }}</el-tag> </span>
        </template>
      </el-table-column>
      <el-table-column prop="monthStr" label="月份" min-width="100" align="center"/>
      <el-table-column prop="targetNumber" label="目标金额" min-width="90" align="center"/>
      <el-table-column prop="accomplishMoney" label="确认金额" min-width="110" align="center">
        <template #default="scope">
          <el-popover placement="top" width="220">
            <div style="display: flex; flex-wrap: wrap; gap: 8px 16px;">
              <div>月定金：{{ scope.row.monthReserve }}</div>
              <div>月订单：{{ scope.row.monthOrder }}</div>
              <div>月退款：{{ scope.row.monthRefund }}</div>
              <div>月器材：{{ scope.row.monthEqu }}</div>
            </div>
            <template #reference>
              <el-tag size="small">{{ scope.row.accomplishMoney }}</el-tag>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="accomplishRate" label="完成率" min-width="100" align="center">
        <template #default="scope">
          <span :style="{ color: scope.row.accomplishRate === '0%' ? '#909399' : '#67C23A' }">
            {{ scope.row.accomplishRate }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="confirmTime" label="确认时间" min-width="170" align="center"/>
      <el-table-column label="签名" min-width="120" align="center">
        <template #default="scope">
          <el-image
              v-if="scope.row.signUrl"
              :src="scope.row.signUrl"
              :preview-src-list="[scope.row.signUrl]"
              style="width: 80px; height: 50px"
              fit="contain"
              preview-teleported
          />
          <span v-else style="color:#909399">无</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          border
          layout="total, prev, pager, next"
          :current-page="query.page"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {confirmPerformanceList,exportConfirmPerformance} from "../../api/orders";
import selectArea from "../../components/SelectArea";
export default {
  name: "PerformanceConfirm",
  components: {
    selectArea,
  },
  data() {
    return {
      yearAndMonth:null,
      pageTotal:0,
      tableLoading:false,
      query:{
        coachName:"",
        year:null,month:null,
        page: 1,
        pageSize: 10,
      },
      tableData:[],
    }
  },
  methods:{
    confirmPerformanceList(){
      this.tableLoading = true;
      confirmPerformanceList(this.query).then(val=>{
        this.tableLoading = false;
        if (val.code === 200){
          this.tableData = val.data.records;
          this.pageTotal = val.data.total;
        }
      })
    },
    exportConfirmPerformance() {
      exportConfirmPerformance(this.query).then(val => {
        if (val.code === 200) {
          this.$message.success("导出成功");
        } else {
          this.$message.error(val.message || "导出失败");
        }
      }).catch(() => {
        this.$message.error("导出失败，请稍后重试");
      });
    },
    handlePageChange(val) {
      this.query.page = val;
      this.confirmPerformanceList();
    },
    getAreaListId(val) {
      this.query.areaList = val;
    },
  },
  created() {
    this.confirmPerformanceList();
  },
  watch:{
    yearAndMonth(newData) {
      if (newData){
        let date = this.yearAndMonth.split('-');
        this.query.year = date[0];
        this.query.month = date[1];
      }else {
        this.query.year = null;
        this.query.month = null;
      }
    }
  }
}
</script>

<style scoped>

</style>